import { useState } from "react";
import styled from "styled-components";
import { SectionSubtitle, SectionTitle } from "components/Style";
import { PARTNER_TABS } from "appLauncher";

const PartnersSection = styled.section`
  padding: 65px 0;
  background-image: url(/assets/home/bar-background-2.png);
  background-position: center;
`;

const PartnersContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  margin-top: 73px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 40px;
`;

const PartnerTabsWrapper = styled.div`
  position: relative;
  min-width: 190px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.08);
  background: transparent;
`;

const PartnerTabs = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
`;

const TabSlider = styled.div<{ $index: number }>`
  position: absolute;
  left: 0;
  top: 0;
  width: 190px;
  height: 97px;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.04);
  transform: translateY(${({ $index }) => $index * 97}px);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;
`;

const PartnerTab = styled.button<{ $active: boolean }>`
  background: transparent;
  border: none;
  outline: none;
  color: ${({ $active }) => ($active ? "#1B2532" : "#999999")};
  font-size: 18px;
  font-weight: ${({ $active }) => ($active ? 700 : 500)};
  width: 190px;
  height: 97px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  transition: color 0.2s;
`;

const PartnerLogos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  justify-content: flex-start;
  align-items: center;
  min-height: 140px;
`;

const PartnerLogo = styled.div`
  width: 192px;
  height: 80px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  font-size: 16px;
  color: #333;
`;

export default function Partners() {
  const [tab, setTab] = useState("tech");
  const current = PARTNER_TABS.find((t) => t.key === tab) || PARTNER_TABS[0];
  const activeIndex = PARTNER_TABS.findIndex((t) => t.key === tab);
  return (
    <PartnersSection>
      <SectionTitle style={{ textAlign: "center" }}>知名合作伙伴</SectionTitle>
      <SectionSubtitle
        style={{ textAlign: "center", marginTop: 8, marginBottom: 24 }}
      >
        Famous partners
      </SectionSubtitle>
      <PartnersContainer>
        <PartnerTabsWrapper>
          <TabSlider $index={activeIndex} />
          <PartnerTabs>
            {PARTNER_TABS.map((t) => (
              <PartnerTab
                key={t.label}
                $active={tab === t.key}
                onClick={() => setTab(t.key)}
              >
                {t.label}
              </PartnerTab>
            ))}
          </PartnerTabs>
        </PartnerTabsWrapper>
        <PartnerLogos>
          {current.list.map((name) => (
            <PartnerLogo key={name}>
              <img src={"/assets/home/" + name + ".png"} />
            </PartnerLogo>
          ))}
        </PartnerLogos>
      </PartnersContainer>
    </PartnersSection>
  );
}
